<!-- 八个主题铺成 4 × 2（每张 6/24 格）：上排四个常规、下排四个紧凑，**同列同色** ——
     卡片按 `APP_THEMES` 的顺序排，那张表的顺序就是照这个摆的（见那边上头那段）。
     `(click)` 在**整格**上，照语言那份的写法。 -->
<nz-row [nzGutter]="[8, 8]">
  @for (spec of themes; track spec.id) {
    <nz-col [nzSpan]="6" (click)="changeTheme(spec.id)">
      <nz-card [nzHoverable]="true" nzSize="small">
        <!-- 色块（主色 / 页面底色，取自表里的 primary 与 ground）：
             一张卡光有名字看不出这个主题长什么样，色块至少先说清「亮底还是暗底、主色是什么」。
             左边那半是主色，右边那半是页面底色 —— 底色不能省：浅色底与暗色底（#ffffff / #000）
             一眼分得出，那正是「玄黑」与另外三列最大的差别。
             同一列的上下两张色块**逐值相同**（紧凑就是同色换密度），这是对的：那几列的「紧」由
             副标题与它是下排这件事说清，不靠色块。 -->
        <!-- 自定义主题的两块色具取用户当前配置（`primaryOf` / `groundOf`），预置取表的静态值 -->
        <div class="theme-preview">
          <span [style.background]="primaryOf(spec)"></span>
          <span [style.background]="groundOf(spec)"></span>
        </div>

        <nz-card-meta [nzTitle]="title" [nzDescription]="desc"></nz-card-meta>
      </nz-card>
    </nz-col>

    <ng-template #title>
        <span>
          <span>{{ spec.label | translate }}</span>

          @if (theme.theme() === spec.id) {
            <span style="float: right">
              <nz-icon nzType="check" />
            </span>
          }
        </span>
    </ng-template>

    <ng-template #desc>
      {{ spec.desc | translate }}
    </ng-template>
  }
</nz-row>

<!-- 底部：进自定义主题页（照组织/项目对话框底部那条「创建」的写法） -->
<div class="theme-dialog-foot">
  <button nz-button (click)="goCustom()">
    <nz-icon nzType="edit" />
    <span>{{ '自定义主题' | translate }}</span>
  </button>
</div>
